import * as React from "react";

import { LayoutEvents, LayoutEventsSubscription } from "../../../Internals/LayoutEvents/LayoutEvents";
import { ArrowRight } from "../../../Internals/Arrows/ArrowRight";
import { ArrowLeft } from "../../../Internals/Arrows/ArrowLeft";

import { Arrow, ArrowsContainer } from "./Arrows.styles";

interface ArrowsProps {
    onLeftArrowClick: () => void;
    onRightArrowClick: () => void;
    arrowsPosition: "Top" | "Bottom" | "Fixed";
    showLeftArrow?: boolean;
    showRightArrow?: boolean;
    visible?: boolean;
}

export class Arrows extends React.Component<ArrowsProps> {
    private layoutSubscription?: LayoutEventsSubscription;
    private readonly arrowContainer = React.createRef<HTMLDivElement>();
    private readonly leftArrow = React.createRef<HTMLDivElement>();
    private readonly rightArrow = React.createRef<HTMLDivElement>();

    public componentDidMount(): void {
        this.layoutSubscription = LayoutEvents.addListener(this.calculateArrowsPosition);
        this.calculateArrowsPosition();
    }

    public componentDidUpdate(): void {
        this.calculateArrowsPosition();
    }

    public componentWillUnmount(): void {
        this.layoutSubscription?.remove();
    }

    public render(): JSX.Element {
        if (!this.props.visible) {
            return <div />;
        }

        return (
            <ArrowsContainer arrowPosition={this.props.arrowsPosition} ref={this.arrowContainer}>
                {this.props.showRightArrow && (
                    <Arrow ref={this.rightArrow} data-tid="ScrollableRightArrow" onClick={this.props.onRightArrowClick}>
                        <ArrowRight />
                    </Arrow>
                )}
                {this.props.showLeftArrow && (
                    <Arrow
                        left
                        ref={this.leftArrow}
                        data-tid="ScrollableLeftArrow"
                        onClick={this.props.onLeftArrowClick}>
                        <ArrowLeft />
                    </Arrow>
                )}
            </ArrowsContainer>
        );
    }

    private readonly calculateArrowsPosition = () => {
        if (this.arrowContainer.current == undefined) {
            return;
        }
        const { left, right } = this.arrowContainer.current.getBoundingClientRect();

        if (this.props.arrowsPosition === "Fixed") {
            if (this.leftArrow.current) {
                this.leftArrow.current.style.position = "fixed";
                this.leftArrow.current.style.left = `${left + 40}px`;
            }
            if (this.rightArrow.current) {
                this.rightArrow.current.style.position = "fixed";
                this.rightArrow.current.style.left = `${right - 88}px`;
            }
        } else {
            if (this.leftArrow.current) {
                this.leftArrow.current.style.left = `${40}px`;
                this.leftArrow.current.style.position = "";
            }
            if (this.rightArrow.current) {
                this.rightArrow.current.style.left = `${right - left - 88}px`;
                this.rightArrow.current.style.position = "";
            }
        }
    };
}
